import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { AllVehiclesResponseModel, VehicleResponseModel } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { Raw, Repository } from 'typeorm';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { VehicleIdRequest } from './dto/vehicle-id-request';
import { VehicleAdapter } from './dto/vehicle.adapter';
import { VehicleMasterDTO } from './dto/vehicle.dto';
import { VehicleRequest } from './dto/vehicle.request';
import { VehicleMaster } from './vehicle-master.entity';


@Injectable()
export class VehicleMasterService {
    constructor(
      private logService:LogsService,
        @InjectRepository(VehicleMaster)
        private vehicleRepository: Repository<VehicleMaster>,
        private vehicleAdapter: VehicleAdapter,
      ) {}
    /**
     * create or update Vehicle 
     * @param vehicleMasterDTO 
     * @param isUpdate 
     * @param request 
     */
    async createVehicle(vehicleMasterDTO: VehicleMasterDTO, isUpdate: boolean,request:Request): Promise<VehicleResponseModel> {
        try {
          let previousValue;
            // to check whether Vehicle exists with the passed  Vehicle  or not. if isUpdate is false, a check will be done whether a record with the passed Vehicle is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed Vehicle  then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
            if (!isUpdate) {
            const VehicleEntity = await this.getVehicleDetailsWithoutRelations(vehicleMasterDTO.registrationNumber);
            if (VehicleEntity) {
                throw new VehicleResponseModel(false,11104, 'Vehicle already exists');         
            } 
            // var notificationStatus='Created';
            }
            // else{
            // var notificationStatus='Updated';
            // }
            const certificatePrevious = await this.vehicleRepository.findOne({where:{vehicleId:vehicleMasterDTO.vehicleId}})
            previousValue = certificatePrevious.vehicleName+','+certificatePrevious.registrationNumber
            const convertedVehicleEntity: VehicleMaster = this.vehicleAdapter.convertDtoToEntity(vehicleMasterDTO,isUpdate);
            const savedVehicleEntity: VehicleMaster = await this.vehicleRepository.save(
            convertedVehicleEntity
            );
            const savedVehicleDto: VehicleMasterDTO = this.vehicleAdapter.convertEntityToDto(savedVehicleEntity);
            if (savedVehicleDto) {
            const present = savedVehicleDto.vehicleName+','+savedVehicleDto.registrationNumber
            // generating resposnse
            const response = new VehicleResponseModel(true,isUpdate ? 11101 : 11100,isUpdate? 'Vehicle Updated Successfully': 'Vehicle Created Successfully',savedVehicleDto);
            const name=isUpdate?'updated':'created'
            const userName = isUpdate ? savedVehicleDto.updatedUser : savedVehicleDto.createdUser
            const displayValue =isUpdate?'Vehicle Updated Successfully': 'Vehicle Created Successfully'
            const newLogDto = new LogsDto(1,name, 'VehicleMaster', savedVehicleDto.vehicleId, true, displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response;
            } else {
            throw new VehicleResponseModel(false,11106,'Vehicle saved but issue while transforming into DTO');
            }
        } catch (error) {
            // when error occures while saving the data , the execution will come to catch block.
            // tslint:disable-next-line: typedef
            return error;
        }
    }
    /**
     * get Vehicle details
     * @param registrationNumber 
     */
    // @LogActions({isAsync: true})
    async getVehicleDetailsWithoutRelations(registrationNumber: string): Promise<VehicleMaster> {
        // tslint:disable-next-line: typedef
        const VehicleResponse = await this.vehicleRepository.findOne({
        where: {registrationNumber: Raw(alias => `registration_number = '${registrationNumber}'`)},
        });
        if (VehicleResponse) {
        return VehicleResponse;
        } else {
        return null;
        }
    }
    /**
     * get All Vehicles Details
     */
    async getAllVehicles(req?:UserRequestDto): Promise<AllVehiclesResponseModel> {
        // const page: number = 1;
        try {
          const VehicleMasterDTO: VehicleMasterDTO[] = [];
          //retrieves all companies
          const vehiclesEntities: VehicleMaster[] = await this.vehicleRepository.find({order :{vehicleName:'ASC'}});
          if (vehiclesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            vehiclesEntities.forEach(vehicleEntity => {
              const convertedstatesDto: VehicleMasterDTO = this.vehicleAdapter.convertEntityToDto(
                vehicleEntity
              );
              VehicleMasterDTO.push(convertedstatesDto);
            });
            const response = new AllVehiclesResponseModel(true,11108,"Vehicles retrieved successfully",VehicleMasterDTO);
           if(req?.createdUser){
            const newLogDto = new LogsDto(1,'view', 'VehicleMaster', 0, true, 'Vehicles retrieved successfully',req.createdUser,'','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
           }
            
            return response;
          } else {
            throw new VehicleResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          return err;
        }
      }
    async getAllActiveVehicles(): Promise<AllVehiclesResponseModel> {
        // const page: number = 1;
        try {
          const VehicleMasterDTO: VehicleMasterDTO[] = [];
          //retrieves all companies
          const vehiclesEntities: VehicleMaster[] = await this.vehicleRepository.find({
            where:{isActive:true},
            order :{vehicleName:'ASC'}});
          if (vehiclesEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            vehiclesEntities.forEach(vehicleEntity => {
              const convertedstatesDto: VehicleMasterDTO = this.vehicleAdapter.convertEntityToDto(
                vehicleEntity
              );
              VehicleMasterDTO.push(convertedstatesDto);
            });
            const response = new AllVehiclesResponseModel(true,11108,"Vehicles retrieved successfully",VehicleMasterDTO);
            return response;
          } else {
            throw new VehicleResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          return err;
        }
      }
      /**
       * 
       * @param vehicleIdRequest 
       * @returns 
       */
        async getVehicleByVehId(vehicleIdRequest:VehicleIdRequest): Promise<VehicleResponseModel> {
        try {
          const vehiclesEntities: VehicleMaster = await this.vehicleRepository.findOne({where:{vehicleId:vehicleIdRequest.vehicleId},order :{vehicleName:'ASC'}});
          if (vehiclesEntities) {
              const convertedstatesDto: VehicleMasterDTO = this.vehicleAdapter.convertEntityToDto(
                vehiclesEntities
              );
            const response = new VehicleResponseModel(true,11108,"Vehicles retrieved successfully",convertedstatesDto);
            return response;
          } else {
            throw new VehicleResponseModel(false,99998, 'Data not found');
          }
        } catch (err) {
          return err;
        }
      }
    /**
     * Active or Deactive Vehicle
     * @param vehicleReq 
     */
      async activateOrDeactivateVehicle(vehicleReq: VehicleRequest): Promise<VehicleResponseModel> {
        try {
            const vehicleExists = await this.getVehicleById(vehicleReq.vehicleId);
            if (vehicleExists) {
                if (vehicleReq.versionFlag !== vehicleExists.versionFlag) {
                    throw new VehicleResponseModel(false,10113, 'Someone updated the current Vehicle information.Refresh and try again');
                } else {
                    
                        const vehicleStatus =  await this.vehicleRepository.update(
                            { vehicleId: vehicleReq.vehicleId },
                            { isActive: vehicleReq.isActive,updatedUser: vehicleReq.updatedUser });
                       
                        if (vehicleExists.isActive) {
                            if (vehicleStatus.affected) {
                                const vehicleResponse: VehicleResponseModel = new VehicleResponseModel(true, 10115, 'Vehicle is de-activated successfully');
                                return vehicleResponse;
                            } else {
                                throw new VehicleResponseModel(false,10111, 'Vehicle is already deactivated');
                            }
                        } else {
                            if (vehicleStatus.affected) {
                                const vehicleResponse: VehicleResponseModel = new VehicleResponseModel(true, 10114, 'Vehicle is activated successfully');
                                return vehicleResponse;
                            } else {
                                throw new VehicleResponseModel(false,10112, 'Vehicle is already activated');
                            }
                        }
                }
            } else {
                throw new VehicleResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    /**
     * get Vehicle while passing id
     * @param vehicleId 
     */
    async getVehicleById(vehicleId: number): Promise<VehicleMaster> {
          const Response = await this.vehicleRepository.findOne({
          where: {vehicleId: vehicleId},
          });
          if (Response) {
          return Response;
          } else {
          return null;
          }
      }
}
